<template>
    <v-card class="elevation-0 rounded-sm">
        <v-card-text>
            <v-row>
                <v-col cols="12" class="d-flex">
                    <h1 style="font-size: 16px;">Listado de filtros</h1>
                    <v-spacer></v-spacer>
                    <DefaultButton
                        label="Crear Filtro"
                        variant='outlined'
                        @click="openModal(filterStore.filterModalOptions)"
                    />
                </v-col>
                <v-divider></v-divider>
                <v-col cols="12">
                    <DefaultDataTable 
                        ref="filterTable"
                        :data-table="dataTable"
                        :filters="filters"
                        @edit="editFilter"
                        @delete="deleteResource"
                    />
                </v-col>
            </v-row>
        </v-card-text>
        <FilterFormModal
            ref="filterFormModal"
            @confirm="refreshTable(filterTable)"
        />
        <DefaultDeleteDialog 
            ref="deleteDialog"
            @deleted="acceptDelete"
        />
    </v-card>    
</template>
<script setup>
    import {ref} from 'vue';
    import DefaultDataTable from '@/components/basics/DefaultDataTable.vue';
    import DefaultButton from '@/components/basics/DefaultButton.vue';
    import { openModal,refreshTable } from '@/composables/modal';
    import FilterFormModal from './FilterFormModal'
    import { useFilterStore } from '@/stores';
    import DefaultDeleteDialog from '@/components/basics/DefaultDeleteDialog.vue';
    
    const deleteDialog = ref(null);
    const filterTable = ref(null);
    const dataTable = {
        endpoint: '/manager/v1/filters',
        headers: [
            {title: "Nombre", value: "name", align: 'center', sortable: false},
            {title: "FECHA DE CREACIÓN", value: "created_at", align: 'center', sortable: false},
            {title: "Opciones", value: "actions", align: 'center', sortable: false},
        ],
        actions: [
            {
                text: "Editar",
                icon: 'mdi mdi-pencil',
                type: 'action',
                method_name: 'edit'
            },
            {
                text: "Eliminar",
                icon: 'mdi mdi-delete',
                type: 'action',
                method_name: 'delete'
            }
        ],
        more_actions: [
        ]
    }
    const filters = {
        q: '',
    };
    const filterStore = useFilterStore();
    const filterFormModal = ref(null);
    const editFilter = async (filter)=>{
        await filterStore.findFilter(filter.id);
        filterFormModal.value.resetFilter();
        openModal(filterStore.filterModalOptions,filterStore.filter)
    } 
    const deleteResource = (filter) =>{
        deleteDialog.value.openDialog(filter);
    }
    const acceptDelete = async(filter) =>{
        await filterStore.deleteFilter(filter.id);
        refreshTable(filterTable.value);
    }
</script>